export let industries = [
  'Agricultura',
  'Almacenamiento',
  'Arquitectura y Planificación',
  'Artes - Artes Escénicas',
  'Artes - Bellas Artes',
  'Artes - Películas / Cíne',
  'Artesanía',
  'Artículos de Lujo y Joyería',
  'Artículos Deportivos',
  'Automatización',
  'Banca',
  'Banca - Inversión',
  'Bibliotecas',
  'Bienes Raíces',
  'Biotecnología',
  'Comunicación - Medios en Línea',
  'Comunicación - Periodísmo',
  'Comunicación - Producción de Medios',
  'Comunicación - Publicación',
  'Comunicación - Redacción y Edición',
  'Comunicación - Relaciones Públicas y Comunicaciones',
  'Construcción',
  'Construcción - Materiales de Construcción',
  'Contabilidad',
  'Deportes',
  'Derecho',
  'Derecho - Judicial',
  'Diseño',
  'Diseño Gráfico',
  'Economía - Capital de Riesgo y Capital Privado',
  'Educación - E-learning',
  'Educación - Primaria / Secundaria',
  'Educación - Universitaria',
  'Electricidad',
  'Electrónica',
  'Eventos / Entretenimiento',
  'Filantropía',
  'Formación Profesional y Coaching',
  'Fotografía',
  'Ganadería',
  'Gestión de Inversiones',
  'Gubernamental',
  'Hotelería',
  'Iglesia',
  'Impresión',
  'Ingeniería Civil',
  'Ingeniería Industrial o Mecánica',
  'Juegos de Azar y Casinos',
  'Logística - Entrega de Paquetes / Cargas',
  'Logística - Importación y Exportación',
  'Logística / Cadena de Suministro',
  'Marketing',
  'Marketing - Investigación de Mercado',
  'Milicia - Ejercito / Naval / Fuerza Aerea',
  'Minería y Metales',
  'Mueble',
  'Museos',
  'Música',
  'Negocios - Comercio Internacional y Desarrollo',
  'Ocio, Viajes y Turismo',
  'Oficina Ejecutiva',
  'Oficina Legislativa',
  'Organización Cívica y Social',
  'Organización Política',
  'Organización sin Fines de Lucro',
  'Outsourcing / Offshoring',
  'Pesca',
  'Petróleo y Energía',
  'Plástico',
  'Producción de Alimentos',
  'Productos Cosméticos',
  'Productos de Papel',
  'Productos Farmacéuticos',
  'Productos Quimicos',
  'Recaudación de Fondos',
  'Reclutamiento y Selección de Personal',
  'Recursos Humanos',
  'Renovables y Medio Ambiente',
  'Restaurante',
  'Salud - Cuidado de la Salud',
  'Salud - Dispositivos Médicos',
  'Salud - Medicina Alternativa',
  'Salud - Práctica Médica',
  'Salud, Bienestar y Fitness',
  'Seguridad e Investigaciones',
  'Seguridad Pública',
  'Seguro',
  'Servicios - Financieros',
  'Servicios - Individuales y Familiares',
  'Servicios - Jurídicos',
  'Servicios - Recreativos',
  'Supermercados',
  'Tabaco',
  'Tecnología - Animación',
  'Tecnología - Hardware',
  'Tecnología - Internet',
  'Tecnología - Juegos de Computadora',
  'Tecnología - Nanotecnología',
  'Tecnología - Networking',
  'Tecnología - Seguridad Informática',
  'Tecnología - Servicios',
  'Tecnología - Software',
  'Telecomunicaciones',
  'Televisión / Radio',
  'Textiles',
  'Traducción y Localización',
  'Transporte - Aerolíneas y Aviación',
  'Transporte / Camiones / Ferrocarriles / Maquinaria',
  'Utilidades',
  'Vehículos',
  'Ventas - Comidas y Bebidas',
  'Ventas - Ropa y Moda',
  'Ventas - Suministros y Equipos para Empresas',
  'Ventas al por Mayor',
  'Ventas al por Menor',
  'Veterinario',
  'Vidrio, Cerámica y Concreto',
  'Vino y Licores',
  'Wireless'
]
